import React from 'react';
import { Navigate } from 'react-router-dom';
import { catalogHubPath } from './catalogRegistry';

const ChangeCategoriesPage: React.FC = () => <Navigate to={catalogHubPath('categories')} replace />;

export default ChangeCategoriesPage;
